"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconScaleHeavy = function SvgIconScaleHeavy(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "scale heavy icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Scale Heavy Icon'), /*#__PURE__*/_react.default.createElement("path", {
    clipRule: "evenodd",
    d: "M24.5 8.499c2.727 0 4.94 2.175 4.94 4.858a4.804 4.804 0 01-1.7 3.657 4.087 4.087 0 00-3.24-1.585 4.109 4.109 0 00-3.24 1.585 4.796 4.796 0 01-1.702-3.657c0-2.683 2.217-4.856 4.942-4.856v-.002zm1.514 25.667V24.5H23.66v9.418l-2.57-2.528-1.664 1.635 5.537 5.443 5.538-5.443-1.664-1.634-2.822 2.775zm13.959 7.786a.834.834 0 01-.446.964.846.846 0 01-.373.084H9.848a.847.847 0 01-.83-.668.834.834 0 01.009-.38l5.548-20.486a.843.843 0 01.82-.617h5.264a3.997 3.997 0 01-.257-1.346 7.349 7.349 0 01-2.476-2.645 7.302 7.302 0 01-.903-3.501C17.02 9.299 20.373 6 24.5 6c4.127 0 7.483 3.3 7.483 7.357 0 2.567-1.348 4.828-3.384 6.146a3.922 3.922 0 01-.26 1.345h5.269c.381 0 .72.254.817.618l5.55 20.486h-.002z"
  }));
};

var _default = SvgIconScaleHeavy;
exports.default = _default;